import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { EventScene } from "./scenes/EventScene";

interface PhaserGamePadDemoProps {
}

interface PhaserGamePadDemoState {
}

const config: GameConfig = {
    title: "Gamepad",
    version: "0.0.1-demo",
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 0 }
        }
    },
    backgroundColor: "#000000"
};

class PhaserGamePadDemo extends React.Component<PhaserGamePadDemoProps, PhaserGamePadDemoState> {
    private game: Phaser.Game;
    constructor(props:PhaserGamePadDemoProps) {
        super(props);
        bindAllOfThis(this, PhaserGamePadDemo.prototype);
    }

    render() {
        // <PhaserGameComponent scenes={[EventScene, UpdateScene]} config={config} />
        return (<div>
            <PhaserGameComponent scenes={EventScene} config={config} />
        </div>);
    }
}

export default PhaserGamePadDemo;



// WEBPACK FOOTER //
// ./src/games/demos/phaserGamePadDemo/Main.tsx